import type { GiornoEvento } from '@eventi/tipi.ts';
import { cn } from '../../lib/cn';

type Props = {
  giorni: GiornoEvento[];
  attivo: string;
  onCambia: (codice: string) => void;
};

/** I giorni dell'evento come pulsanti affiancati: si guarda un giorno alla volta. */
export function SceltaGiorno({ giorni, attivo, onCambia }: Props) {
  return (
    <div role="group" aria-label="Giorno" className="inline-flex flex-wrap gap-1 rounded-lg bg-gray-100 p-1">
      {giorni.map((g) => (
        <button
          key={g.codice}
          type="button"
          aria-pressed={attivo === g.codice}
          onClick={() => onCambia(g.codice)}
          className={cn(
            'rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500',
            attivo === g.codice ? 'bg-white text-gray-900 shadow-sm' : 'text-neutral-500 hover:text-neutral-800',
          )}
        >
          {g.nome}
        </button>
      ))}
    </div>
  );
}
